module.exports = __webpack_public_path__ + "img/nong-en.01f94cb1.gif";